import { useTranslation } from 'react-i18next';
import Tabs from './Tabs';
import OverviewTab from './OverviewTab';
import TransfersTab from './TransfersTab';
import CategoriesTab from './CategoriesTab';
import ComplianceBanner from './ComplianceBanner';
import AppLayout from '../../components/AppLayout';
import { Icon, PageHeader, BtnPrimary, BtnSecondary } from '../regureStyles';
import useDataResidencyFunctions from './useDataResidencyFunctions';

const DataResidencyScreen = () => {
  const { t } = useTranslation();
  const {
    activeTab,
    setActiveTab,
    regions,
    categories,
    auditedAt,
    allCompliant,
    auditRunning,
    downloading,
    loading,
    tabs,
    handleRunAudit,
    handleDownloadReport,
  } = useDataResidencyFunctions();

  if (loading) {
    return (
      <AppLayout>
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',padding:60}}><div style={{width:36,height:36,border:'3px solid #e2e8f0',borderTopColor:'#7c3aed',borderRadius:'50%',animation:'spin 0.8s linear infinite'}}/></div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div style={{ flex: 1, overflow: 'auto', padding: '32px 40px' }}>
        <PageHeader
          title={t('screens.dataResidency.title')}
          subtitle={t('screens.dataResidency.subtitle')}
          actions={
            <div style={{ display: 'flex', gap: 10 }}>
              <BtnSecondary onClick={handleDownloadReport} disabled={downloading}>
                <Icon name='file-text' size={15} />
                {downloading ? t('screens.dataResidency.downloading') : t('screens.dataResidency.exportReport')}
              </BtnSecondary>
              <BtnPrimary onClick={handleRunAudit} disabled={auditRunning}>
                <Icon name='shield' size={15} />
                {auditRunning ? t('screens.dataResidency.runningAudit') : t('screens.dataResidency.runAudit')}
              </BtnPrimary>
            </div>
          }
        />

        {/* Compliance Banner */}
        <ComplianceBanner auditedAt={auditedAt} allCompliant={allCompliant} />

        {/* Tabs */}
        <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

        {activeTab === 'overview' && <OverviewTab regions={regions} />}

        {activeTab === 'categories' && (
          <CategoriesTab categories={categories} />
        )}

        {activeTab === 'transfers' && (
          <TransfersTab />
        )}
      </div>
    </AppLayout>
  );
};

export default DataResidencyScreen;
